export const codeData = {
    //系统所有权限码

    /**
     * 脱敏管理
     */
    DESENSITIZATIONMANAGE: 'desensitization.manage',//脱敏管理
    DESENSITIZATIONVIEW: 'desensitization.view',//查看脱敏信息

    /**
     * 商户管理
     */
    MERCHANTMANAGER: 'merchant.manage',//商户管理
    MERCHANTDETAIL: 'merchant.detail',//商户详情
    AGENTTAGBIND: 'agent-tag.bind',//添加标签
    AGENTTAGDELETE: 'agent-tag.delete',//删除标签
    AGENTTAGADD: 'agent-tag.add',//新增标签
    
    /**
     * 打款统计
     */
    TRADEMANAGE:'trade.manage',

    /**
     * 我的导出
     */
    EXPORTSMANAGE: 'export.manage',//我的导出

    /**
     * 权限管理
     */
    PERMISSIONMANAGE: 'permission.manage',//权限管理
    /**
     * 用户管理
     */
    USERSINDEX: 'users.index',//用户管理
    USERSCREATE: 'users.create',//添加用户
    USERSUPDATE: 'users.update',//编辑用户
    USERHASROLESUPDATE: 'user-has-roles.update',//绑定角色
    USERSTATEFORBIDDEN: 'user-login.forbidden',//禁止/允许登录
    USERSTATEENABLE: 'user-state.forbidden',//禁用/启用
    USEREXPORT: 'user.export',//导出
    //--------------

    /**
     * 角色管理
     */
    ROLESINDEX: 'roles.index',//角色管理
    ROLESCREATE: 'roles.create',//添加角色
    ROLESUPDATE: 'roles.update',//编辑角色信息
    ROLEHASPERMISSIONSUPDATE: 'role-has-permissions.update',//角色授权
    ROLESDELETE: 'roles.delete',//删除角色

    /**
    * 签约管理
    */
    INDIVIDUALSMANAGE: 'individuals.manage',//签约管理

    /**
     * 个体信息
     */
    SIGNPROTOTEMPLATESDOWNLOAD: 'sign-proto-templates.download',//协议模板预览/下载
    INDIVIDUALSINDEX: 'individuals.index',//个体信息
    INDIVIDUALSBATCHEXPORT: 'individuals.batch-export',//导出
    SIGNRECORDSCREATE: 'sign-records.create',//发起签约
    INDIVIDUALSFORBIDDEN: 'individuals.forbidden',//允许/禁止签约
    INDIVIDUALSUPDATE: 'individuals.update',//编辑手机号
    INDIVIDUALSVIEW: 'individuals.view',//个体详情

    /**
     * 签约批次
     */
    SIGNBATCHESINDEX: 'sign-batches.index',//签约批次
    BATCHESMULTIPLESIGN: 'batches.multiple.sign',//导入并批量签约
    SIGNBATCHESEXPORT: 'sign-batches.export',//导出
    SIGNBATCHSMSREMIND: 'sign-batch-sms.remind',//短信提醒
    /**
     * 签约明细
     */
    AGREEMENTSINDEX: 'agreements.index',//签约明细
    AGREEMENTSREMIND: 'agreements.remind',//短信提醒
    AGREEMENTSPROTOTEMPLATESDOWNLOAD: 'agreements-proto-templates.download',//协议附件预览/下载
    AGREEMENTSBACK: 'agreements.back',//撤回签约    
    AGREEMENTSREMOVESIGN: 'agreements.remove-sign',//解除协议
    AGREEMENTSBATCHEXPORT: 'agreements.batch-export',//导出
    AGREEMENTSVIEW: 'agreements.view',//查看签约详情
    AGREEMENTSDELETE: 'agreements.delete',//删除签约

}



